/* eslint-disable */
import axios from "../cotAxios";

export default {
    // -----------------------------------------------------------------------------------
    // おすすめビデオ
    // 取得
    GetRecommendVideoList(): Promise<any> {
        return axios.get("/api/getRecommendVideoList")
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 編集
    UpdateRecVideos(videoIds: string[]): Promise<any> {
        return axios.post("/api/updateRecVideo",videoIds)
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 追加
    AddVideoToRec(videoId: string): Promise<void> {
        return axios.post("/api/addVideoToRec", {videoId: videoId})
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // -----------------------------------------------------------------------------------
    // おすすめプログラム
    // 取得
    GetRecommendProgramList(userId: string): Promise<any> {
        return axios.get("/api/getRecommendProgramList", {params: {},withCredentials: true})
            .then(({data}) => data)
   },
    // 編集
    UpdateRecPrograms(programIds: string[], userId: string): Promise<any> {
        return axios.post("/api/updateRecProgram",{programIds: programIds, userId: userId})
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 追加
    addRecProgram(id: number | string, userId: string): Promise<number[]> {
        return axios.post("/api/addRecProgram",{programId: id, userId: userId})
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 削除
    delRecProgram(id: number | string, userId: string): Promise<number[]> {
        return axios.post("/api/deleteRecProgram", {programId: id, userId: userId})
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // -----------------------------------------------------------------------------------
    // おすすめプロフェショナル
    // 取得
    GetRecommendProfessionalList(): Promise<any> {
        return axios.get("/api/getRecommendProfessionalList")
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 編集
    UpdateRecProfessionals(professionalIds: string[]): Promise<any> {
        return axios.post("/api/updateRecProfessional",professionalIds)
            .then(({data}) => data)
            .catch((error) => {return error});
   },
    // 追加
    addRecProfessional(id: number): Promise<number[]> {
        return axios.post(`/api/addRecProfessional/${id}`)
            .then(({data}) => data);
   },
    // 削除
    removeRecProfessional(id: number): Promise<number[]> {
        return axios.post(`/api/deleteRecProfessional/${id}`)
            .then(({data}) => data);
   },
    // -----------------------------------------------------------------------------------
    // 新着ビデオ
    // 取得
    GetNewVideoList(userId: string): Promise<any> {
         return axios.get("/api/getNewVideoList", {params: {},withCredentials: true})
            .then(({data}) => data);
   },
    // -----------------------------------------------------------------------------------
    // ユーザー視聴履歴
    // 取得
    GetVideosByUser(userId: string): Promise<any> {
        return axios.get("/api/getVideoListByUser", {params: {},withCredentials: true})
            .then(({data}) => data);
   }
}
